import { render, staticRenderFns } from "./UnionTeamList.vue?vue&type=template&id=643c72b9"
import script from "./UnionTeamList.vue?vue&type=script&lang=js"
export * from "./UnionTeamList.vue?vue&type=script&lang=js"
import style0 from "./UnionTeamList.vue?vue&type=style&index=0&id=643c72b9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports